import { render, staticRenderFns } from "./vValue.vue?vue&type=template&id=3afddea2&scoped=true&"
import script from "./vValue.vue?vue&type=script&lang=js&"
export * from "./vValue.vue?vue&type=script&lang=js&"
import style0 from "./vValue.vue?vue&type=style&index=0&id=3afddea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afddea2",
  null
  
)

export default component.exports